<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="fas fa-file-upload" class="q-mb-sm" /> {{ $t('code_apple') }}
        </div>

        <div class="row gutter-xs q-mb-sm">
            <div class="col-4">
                <q-input v-model="total_code" float-label="Total de codigos" :disable="true"/>
            </div>
            <div class="col-4">
                <q-input v-model="used" float-label="Total de codigos usados" :disable="true"/>
            </div>
            <div class="col-4">
                <q-input v-model="not_used" float-label="Total de codigos não usados" :disable="true"/>
            </div>
        </div>

        <q-table
            :data="codes"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            >

            <template slot="top-right" slot-scope="props">
                <q-search v-model="filter" icon="fas fa-search" :placeholder="$t('search')" :debounce="500" />
            </template>

            <template slot="top" slot-scope="props">
                <div class="col" />
                <q-btn color="secondary" icon="fas fa-sync" :label="$t('update_codes')" class="q-mr-md" @click="request({ pagination: server_pagination })" />
                <q-btn color="secondary" icon="fas fa-upload" :label="$t('import')" @click="show_modal=true" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="created_date" :props="props">
                    {{ fDate(props.row.created_date) }}
                </q-td>

                <q-td key="code" :props="props">
                    {{ props.row.code }}
                </q-td>

                <q-td key="user_full_name" :props="props">
                    {{ props.row.user_full_name }}
                </q-td>

                <q-td key="user_email" :props="props">
                    {{ props.row.user_email }}
                </q-td>
            </q-tr>
        </q-table>

        <q-modal v-model="show_modal" :content-css="{minWidth: '80vw', maxWidth: '100vw', minHeight: '90vh'}" @hide="show_modal = false">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_modal = false" icon="fas fa-times" />
                    <q-toolbar-title>
                            {{ $t('import') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm q-mt-sm">
                        <div class="col-12">
                            <div class="col-xs-12 col-sm-12">
                                <p class="caption">{{ $t('file') }}</p>
                                <uploader content_type="" @fileUploaded="fileUploaded" :multiple="false" :error="$v.file_url.$error" />

                                <p v-if="file_url" class="q-mt-md file-url">
                                    <q-icon name="fas fa-check" color="positive" />
                                    <a :href="file_url" target="_blank"> {{ $truncateLink(file_url) }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="show_modal = false" />
                        </div>
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </q-page>
</template>

<script>
import { date } from 'quasar'
import { mapGetters } from 'vuex'
const { formatDate } = date
import { required, requiredIf } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'
export default {
    i18nOptions: { namespaces: ['custom', 'common', 'imports'] },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            loading: false,
            codes: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'name',
                    sortable: false,
                },
                {
                    name: 'created_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'created_date',
                    sortable: false,
                },
                {
                    name: 'code',
                    required: true,
                    label: 'code',
                    align: 'left',
                    field: 'code',
                    sortable: false,
                },
                {
                    name: 'user_full_name',
                    required: true,
                    label: 'full_name',
                    align: 'left',
                    field: 'user_full_name',
                    sortable: false,
                },
                {
                    name: 'user_email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'user_email',
                    sortable: false,
                }
            ],
            filter: '',
            show_modal: false,
            file_url: '',
            qtn_code_user: 0,
            used: 0,
            not_used: 0,
            total_code: 0
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            areas: 'registration_lists/country_areas',
            user_groups: 'registration_lists/group_users',
            banner_types: 'registration_lists/banner_types',
            profiles: 'registration_lists/profiles',
            num_rows: 'datatable/num_rows',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.infoCode()
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get('/admin_import/codes_app/?' + this.$qs.stringify(data), this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.codes = []

                this.codes = response.data.results.map(c => {
                    return {
                        ...c,
                        id: c.id,
                        code: c.code
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        infoCode() {
            this.$axios.get('/admin_import/codes_app/qty_code/', this.getHeader)
            .then(response => {

                this.used = response.data.used
                this.not_used = response.data.not_used
                this.total_code = response.data.total_code
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        saveData() {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = {
                    file_url: this.file_url
                }

                this.$axios.post(`/admin_import/codes_app/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('at_the_end_of_the_process_a_notification_is_sent_this_process_can_take_a_few_minutes'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })



                        this.show_modal =  false
                        this.$q.loading.hide()
                        this.request({
                            pagination: this.server_pagination
                        })
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        fileUploaded(url) {
            this.file_url = url
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },
    },

    validations() {
        return {
            file_url: { required },
        }
    },

    created() {
        this.loadPagination()
        this.request({
            pagination: this.server_pagination
        })

    }
}
</script>

<style lang="stylus" scoped>

</style>
